import { CircularProgress, Typography } from '@material-ui/core'
import PeopleAltIcon from '@material-ui/icons/PeopleAlt'

import SessionRow from '../../components/SessionRow'
import { getTranslate } from '../../localization'
import { SessionsResponse } from '../../types/iamSessions'
import useStyles from './styles/sessionsTable.styles'

type SessionsTableProps = {
  loadingForGettingSessions: boolean
  sessionsData: SessionsResponse | undefined
}
export default function SessionsTable({
  loadingForGettingSessions,
  sessionsData
}: SessionsTableProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableWrapper}>
        <div className={classes.tableHeader}>
          <Typography className={classes.headerText}>
            {getTranslate('Session ID')}
          </Typography>
          <Typography className={classes.headerText}>
            {getTranslate('State')}
          </Typography>
          <Typography className={classes.headerText}>
            {getTranslate('Initiated')}
          </Typography>
          <Typography className={classes.headerText}>
            {getTranslate('Last Activity')}
          </Typography>
          <Typography className={classes.headerText}>
            {getTranslate('Terminated')}
          </Typography>
          <Typography className={classes.headerText}>
            {getTranslate('Expire (min)')}
          </Typography>
          <Typography className={classes.headerText}>
            {getTranslate('Absolute (min)')}
          </Typography>
        </div>
        {loadingForGettingSessions ? (
          <div className={classes.loadingContainer}>
            <CircularProgress size={36} />
          </div>
        ) : sessionsData && sessionsData?.sessions?.length > 0 ? (
          <div className={classes.content}>
            {sessionsData.sessions.slice(0, 6).map((session) => (
              <SessionRow key={session.id} session={session} hideEmail />
            ))}
          </div>
        ) : (
          <div className={classes.emptyState}>
            <PeopleAltIcon className={classes.emptyIcon} />
            <Typography>{getTranslate('No sessions found')}</Typography>
          </div>
        )}
      </div>
    </div>
  )
}
